import CustomZObject from './CustomZObject.js';
import ParameterContext from "effects/ParameterContext.js";
import Envelope from "modulators/Envelope.js";

/**
 * Custom object for controling and managing groups within a project
 * This includes the group volumes but also auto-adding tracks to groups
 *
 */
export default class ZEnvelope extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        // create an envelope

        this.envelope = new Envelope(
            this.sequencerEngine, this.sequencerEngine.mixSession, new ParameterContext().forZObject(this.zObject), 0);

        this.envelope.attack = 5;
        this.envelope.decay = 90;
        this.envelope.sustain = 0.1;
        this.envelope.release = 15;

        this.newInlet("modulate parameter", ([msg]) => this.onParameter(msg));
        this.newInlet("trigger attack release", ([msg]) => this.onTriggerAttackRelease(msg));

        this.newInlet("attack", ([msg]) => this.envelope.attack = msg);
        this.newInlet("decay", ([msg]) => this.envelope.decay = msg);
        this.newInlet("release", ([msg]) => this.envelope.release = msg);
        this.newInlet("sustain", ([msg]) => this.envelope.sustain = msg);
        this.newOutlet("depth mapped");
    }

    onParameter(msg) {
        // modulate parameter
        if (!Array.isArray(msg)) {
            return;
        }
        let [effect, parameterName, min, max] = msg;

        if (!parameterName || !effect) {
            return;
        }

        // find the parameter
        let parameter = effect.parameters.find(x => x.name.toLowerCase().includes(parameterName.toLowerCase()));
        console.log("parameter found=", parameter);
        if (!parameter || !parameter.audioParam) {
            return;
        }

        let createdDepth = false;
        if (!parameter.depthParameter) {
            parameter.initDepth();
        }
        this.envelope.connect(parameter.audioParam, parameter, 0);
        parameter.connectToDepth(undefined, this.envelope, createdDepth);

        if (min !== undefined && max !== undefined) {
            let scale = this.envelope.getScaleForParameter(parameter);
            scale.min = min;
            scale.max = max;
        }

        console.log('sending depth mapped=', parameter.depthParameter);
        this.sendMessage("depth mapped", parameter.depthParameter);
    }

    // will receive triggers
    onTriggerAttackRelease(msg) {
        let {time, duration, velocity} = msg;

        this.envelope.triggerAttackRelease(duration, time, velocity);
    }
}

 
